<template>
  <div class="row mt-3">
    <div class="col-md-12">
      <div class="section-header">
        <h3>Gérer ma SIM</h3>
        <p class="text-muted font-weight-light">
          Opérations et paramétrages pour carte SIM
        </p>
      </div>
    </div>

    <ServiceCard
      :key="index"
      v-for="(item, index) in items.slice(0, 4)"
      :description="item.description"
      :title="item.title"
      :link_type="item.link_type"
      :extern_link="item.extern_link"
      :url="item.url"
      :modal_id="item.action"
    />

    <div class="col-md-12 see-more">
      <SeeMoreBtn :btn_class="'float-right'" :path="'/carte-sim/'" />
    </div>
  </div>
</template>

<script>
import ServiceCard from "@/components/utils/ServiceCard";
import SeeMoreBtn from "@/components/utils/SeeMoreBtn";

export default {
  components: { ServiceCard, SeeMoreBtn },
  name: "HomeSimBox",
  data: function () {
    return {
      items: this.utils_get_config_item("sim_services"),
    };
  },
  mounted: async function () {
  },
  methods: {},
};
</script>
<style scoped lang="css">
.see-more {
  margin-top: -30px !important;
}
@media only screen and (max-width: 600px) {
  .see-more {
    margin-top: 0 !important;
  }
}
</style>
